import { SessionXAxis } from "../../types";
import { formatTimestamp } from "../../util";

export const formatBucketLabel = (start: number, xAxis: SessionXAxis) =>
  xAxis === "moment" ? `${Math.ceil(start)}` : formatTimestamp(start);
